/**
 * admin_json_form_controller.js — Admin edit forms saved through a JSON route (Stimulus).
 *
 * The admin edit pages (business, user) save through their entity's PUT route
 * under /admin/api, which reads JSON. On submit this sends the named fields
 * (a checkbox as true/false, anything else as its value), then toasts and
 * moves to the entity's detail page with a Turbo visit. A refused save toasts
 * the server's message and leaves the form as typed.
 *
 * Values: url (the PUT route), successUrl (where a saved form goes), success
 * (the toast text), fields (the input names to send; any other input, such as
 * a read-only email shown for reference, stays out of the request).
 * Targets: submit (the Save button, disabled while the request runs).
 *
 * Templates: templates/admin/edit_business.html, templates/admin/edit_user.html
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static values = { url: String, successUrl: String, success: String, fields: Array };
    static targets = ['submit'];

    save(event) {
        event.preventDefault();
        this.submitTarget.disabled = true;

        fetch(this.urlValue, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify(this._body())
        })
        .then(function (response) { return response.json(); })
        .then((data) => {
            if (!data.success) throw new Error(data.message || 'Unknown error');
            window.showNotification(this.successValue, 'success');
            window.Turbo.visit(this.successUrlValue);
        })
        .catch((error) => {
            window.showNotification('Failed to save: ' + error.message, 'error');
            this.submitTarget.disabled = false;
        });
    }

    _body() {
        const body = {};
        this.fieldsValue.forEach((name) => {
            const input = this.element.elements[name];
            body[name] = input.type === 'checkbox' ? input.checked : input.value;
        });
        return body;
    }
}
